// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container[data-v-0482523c],.theme--light.v-card[data-v-0482523c]{background:#e9f5fe}.width-100[data-v-0482523c]{width:100%}.banner-text[data-v-0482523c]{font-size:2.5rem!important}.banner-text-subtitle[data-v-0482523c]{font-size:1.2rem!important}", ""]);
// Exports
module.exports = exports;
